import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

function CardSkeleton() {
  return (
    <Skeleton variant="rounded" height={120} sx={{ borderRadius: 2 }} />
  );
}

export default function FinanceiroLoading() {
  return (
    <Stack spacing={3}>
      <Skeleton variant="rounded" height={56} sx={{ borderRadius: 1 }} />
      {[1, 2, 3, 4].map((block) => (
        <Box key={block}>
          <Skeleton variant="text" width={180} height={32} sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <CardSkeleton />
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Stack>
  );
}
